import { Controller } from 'stimulus'

const EVERY_MS   = 3000
const GIVE_UP_MS = 10 * 60 * 1000 // un article long sur le meilleur modèle prend des minutes

export default class extends Controller {
  static targets = ['writing', 'content', 'insert', 'uploadState', 'coverPreview']

  connect() {
    this.hint = this.hasUploadStateTarget ? this.uploadStateTarget.textContent : ''
    this.watchCover()
    if (this.data.get('writing') !== '1') return

    if (!this.hasWritingTarget) return

    this.startedAt = Date.now()
    this.writingTarget.hidden = false
    this.timer = setInterval(() => this.poll(), EVERY_MS)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  // ── Writing in progress ──────────────────────────────────────────────────
  poll() {
    if (Date.now() - this.startedAt > GIVE_UP_MS) return this.stop()

    fetch(this.data.get('statusUrl'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(response => (response.ok ? response.json() : null))
      .then(data => {
        if (!data || !data.written) return
        this.stop()
        window.location.href = window.location.pathname
      })
      .catch(() => {})
  }

  stop() {
    if (this.timer) clearInterval(this.timer)
    if (this.hasWritingTarget) this.writingTarget.hidden = true
  }

  // ── Photo dans le corps de l'article ─────────────────────────────────────
  insertPhoto(event) {
    const file = event.target.files[0]
    if (!file || !this.hasContentTarget) return

    const body = new FormData()
    body.append('image', file)
    this.say(this.data.get('uploadingText'))

    fetch(this.data.get('uploadUrl'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-CSRF-Token': this.csrfToken(), Accept: 'application/json' },
      body
    })
      .then(response => response.json())
      .then(data => {
        if (!data.url) throw new Error(data.error || 'upload')
        this.insertAtCursor(this.figure(data.url, file.name))
        this.say(this.hint)
      })
      .catch(() => this.say(this.data.get('uploadErrorText')))
      .finally(() => { event.target.value = '' })
  }

  figure(url, name) {
    const caption = name.replace(/\.[^.]+$/, '').replace(/[-_]+/g, ' ')
    return `\n<figure>\n  <img src="${url}" alt="${caption}">\n  <figcaption>${caption}</figcaption>\n</figure>\n`
  }

  insertAtCursor(snippet) {
    const field = this.contentTarget
    const start = field.selectionStart
    const end   = field.selectionEnd
    field.value = field.value.slice(0, start) + snippet + field.value.slice(end)
    field.selectionStart = field.selectionEnd = start + snippet.length
    field.focus()
  }

  watchCover() {
    const input = this.element.querySelector('.bo-blog-form__file')
    if (!input || !this.hasCoverPreviewTarget) return

    input.addEventListener('change', () => {
      const file = input.files[0]
      if (!file) return

      const preview = this.coverPreviewTarget
      const url = URL.createObjectURL(file)
      if (preview.tagName === 'IMG') {
        preview.src = url
      } else {
        const img = document.createElement('img')
        img.src = url
        img.setAttribute('data-blog--editor-target', 'coverPreview')
        preview.replaceWith(img)
      }
    })
  }

  say(message) {
    if (this.hasUploadStateTarget) this.uploadStateTarget.textContent = message
  }

  csrfToken() {
    const tag = document.querySelector('meta[name="csrf-token"]')
    return tag ? tag.content : ''
  }
}
